import { getAssetFromLocalStorage } from '../../../utils';

function getItemUploadedSize({ loaded, assetId }) {
  if (loaded) {
    return loaded;
  }

  const localAsset = getAssetFromLocalStorage(assetId);

  return localAsset ? localAsset.uploadedBytes : 0;
}

export default getItemUploadedSize;